export const blockIconsTravelSmokingRoomsNew = (
	<span className='material-symbols-outlined'>smoking_rooms</span>
);
